$(function() {
  if (IB.punch_id) {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/inspiration-guide/articles/' + IB.punch_id + '/punch/'
    }).done(function(data){
      $('#article-current-count').html(data.updated);
      $('#article-next-count').html(data.updated + 1);
    });
  }

  $(document).on("click", "[data-like]", function(event) {
    event.preventDefault();

    if ($(this).hasClass('clicked')) {
      return;
    }

    var url = $(this).data('like');
    $.post(url);

    $(this).addClass('clicked').attr('disabled', 'disabled');
  });
});
